import AOS, { AosOptions } from 'aos';
import { computed } from 'vue';

export function useAOS(option?: Record<string, any>)
{
    let mergeOption:AosOptions = {
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // V3版本：class applied after initialization
        animatedClassName: 'aos-animate', // V3版本：class applied on animation
        useClassNames: false, // V3版本：if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: -50, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1200, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // V3版本：whether elements should animate out while scrolling past them
        anchorPlacement: 'top-center' // V3版本：defines which position of the element regarding to window should trigger the animation
    };

    if (!option)
    {
        mergeOption = Object.assign({}, mergeOption, option);
    }

    AOS.init(mergeOption);
}

export const pageHalfOffset = computed(() =>
{
    console.log('pageHalfOffset', -document.documentElement.clientHeight);
    return  -document.documentElement.clientHeight / 2;
});
